import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LoginComponent } from './modules/auth/login/login.component';
import { AuthGuard } from './core/guards/auth.guard';
import { UserRoleGuard } from './core/guards/userRole.guard';
import { Role, userType } from './core/models/role';
import { InstagramAuthCallbackComponent } from './shared/components/social-connections/instagram-auth-callback/instagram-auth-callback.component';
import { DemoAppComponent } from './shared/components/demo/demo-app/demo-app.component';

const appRoutes: Routes = [
  {
    path: 'login',
    // canActivate: [UserRoleGuard],
    data: { roles: ['login'] },
    component: LoginComponent,
  },
  {
    path: 'demo-app',
    loadChildren: () =>
      import('./shared/components/demo/demo-app/demo-app.module').then(
        (m) => m.DemoAppModule
      ),
  },
  {
    path: 'customer',
    canActivate: [AuthGuard, UserRoleGuard],
    data: { roles: [Role.CUSTOMER] },
    loadChildren: () =>
      import('./modules/client/customer/customer.module').then(
        (mod) => mod.CustomerModule
      ),
  },
  {
    path: 'dashboard',
    canActivate: [AuthGuard, UserRoleGuard],
    data: { roles: [Role.USER], types: [userType.BASIC, userType.PREMIUM] },
    loadChildren: () =>
      import('./modules/client/dashboard/dashboard.module').then(
        (mod) => mod.DashboardModule
      ),
  },
  {
    path: 'root',
    canActivate: [AuthGuard, UserRoleGuard],
    data: { roles: [Role.ROOT] },
    loadChildren: () =>
      import('./modules/root/root.module').then((mod) => mod.RootModule),
  },
  {
    path: 'auth/instagram/callback',
    canActivate: [AuthGuard, UserRoleGuard],
    data: { roles: [Role.ROOT, Role.CLIENT, Role.USER] },
    component: InstagramAuthCallbackComponent,
  },
  {
    path: 'manager',
    canActivate: [AuthGuard, UserRoleGuard],
    data: { roles: [Role.MANAGER] },
    loadChildren: () =>
      import('./modules/manager/manager.module').then(
        (mod) => mod.ManagerModule
      ),
  },
  {
    path: 'client',
    canActivate: [AuthGuard, UserRoleGuard],
    data: { roles: [Role.CLIENT] },
    loadChildren: () =>
      import('./modules/client/client-admin/client-admin.module').then(
        (mod) => mod.ClientAdminModule
      ),
  },
  {
    path: 'crop',
    canActivate: [AuthGuard, UserRoleGuard],
    data: { roles: [Role.USER], types: [userType.SIMPLE] },
    loadChildren: () =>
      import('./modules/crop/crop.module').then((mod) => mod.CropModule),
  },
  { path: '', redirectTo: '/login', pathMatch: 'full' },
  { path: '**', redirectTo: '/login' },
];

@NgModule({
  imports: [RouterModule.forRoot(appRoutes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
